<template>
  <div class="HomeHeader">
    <div v-if="showHandler">
      <router-link to="/home" active-class="clickColor">
        <span class="home">首页</span>
      </router-link>
      <!-- <router-link to="/solution"  class="solution"> -->
      <a class="solution cursorPointer" @click="solutionFn(0)">
        <span class="solution" :class="{'clickColor':isSolution}">解决方案</span>
        <div class="select">
          <ul @click.stop="stopPop">
            <li @click="solutionFn(0)">网贷行业</li>
            <li @click="solutionFn(1)">银行业</li>
            <li @click="solutionFn(2)">人力资源</li>
            <li @click="solutionFn(3)">保险行业</li>
            <li @click="solutionFn(4)">消费金融</li>
            <li @click="solutionFn(5)">互联网平台</li>
            <li @click="solutionFn(6)">租赁平台</li>
            <li @click="solutionFn(7)">旅游行业</li>
            <li @click="solutionFn(8)">其他行业</li>
          </ul>
        </div>
      </a>
      <!-- </router-link> -->
      <router-link to="/verification/validate" active-class="clickColor">
        <span class="validation">验证</span>
      </router-link>
     <!-- <router-link to="/verification/about" active-class="clickColor" class="aboutOut">
        <span class="attention">
          关注我们
           <img clssass="validation_image" src="../../assets/images/image/head/ewm_img.png" alt> 
        </span>
      </router-link>-->
      <router-link to="/verification/helpCenter" active-class="clickColor">
        <span class="validation">帮助中心</span>
      </router-link>
      <router-link to="/verification/login" active-class="clickColor" class="cursorPointer loginHome">
        <span class="btnLogin">登录</span>
        <!-- <button class="btnLogin cursorPointer">登录</button> -->
      </router-link>
      <router-link to="/verification/register" active-class="clickColor">
        <span class="register">注册</span>
        <!-- <button class="btnRegidter cursorPointer">注册</button> -->
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    showHandler() {
      if (this.$route.fullPath.indexOf("paySuccess") > -1) {
        return false;
      } else {
        return true;
      }
    },
    isSolution() {
      return this.$route.path.indexOf("solution") > -1;
    }
  },
  methods: {
    solutionFn(num) {
      this.$router.push(`/solution?type=${num}`);
    },
    stopPop() {
      return false;
    }
  }
};
</script>
<style lang="scss">
.HomeHeader {
  float: right;
  height: 50px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  .clickColor {
    color: #b41c2e;
  }
  a {
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    span {
      font-size: 14px;
      color: #fff;
    }
    span:hover {
      color: #DB2D2D;
    }
  }
  .aboutOut {
    position: relative;
    &:hover {
      img {
        display: block;
      }
    }
    img {
      display: none;
      position: absolute;
      top: 30px;
      left: 50%;
      margin-left: -45px;
      z-index: 666666;
    }
  }
  .loginHome {
    position: relative;
    margin-left: 30px;
  }
  .loginHome::after {
    position: absolute;
    content: "";
    display: block;
    width: 1px;
    height: 16px;
    background-color: #fff;
    opacity: 0.6;
    top: 0;
    left: -15px;
    top: 17px;
  }
  .router-link-exact-active {
    span {
      color: #E84848;
    }
  }
  a:last-child {
    padding-right: 0;
  }
  .solution {
    position: relative;
    &:hover {
      .select {
        height: 316px;
        opacity: 1;
      }
    }
    .select {
      width: 100px;
      height: 0px;
      position: absolute;
      top: 50px;
      left: 50%;
      margin-left: -48px;
      background: #fff;
      box-sizing: border-box;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
      opacity: 0;
      transition: all 0.5s;
      overflow: hidden;
      z-index: 666666;
      ul {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        position: relative;
        li {
          width: 100%;
          height: 32px;
          line-height: 32px;
          font-size: 12px;
          color: #000;
          text-align: center;
          border-bottom: 1px solid rgb(220, 220, 220);
          &:hover {
            color: #cb3737;
          }
        }
        li:last-child {
          border: 0;
        }
      }
      ul:before {
        content: "";
        width: 0;
        height: 0;
        border-width: 0 6px 7px;
        border-style: solid;
        border-color: transparent transparent #fff; /*透明 透明  灰*/
        position: absolute;
        top: -7px;
        left: 50%;
        margin-left: -9px;
      }
    }
  }
}
</style>
